import { LicensePeriodEnum } from "requests";

export const PERIOD_OPTIONS = [
  { label: "Monthly", value: LicensePeriodEnum.Monthly },
  { label: "Yearly", value: LicensePeriodEnum.Yearly }
];

export const STATUS_OPTIONS = [
  { label: "Active", value: "true" },
  { label: "Inactive", value: "false" }
];
